import { render, staticRenderFns } from "./InitForm.vue?vue&type=template&id=608a1c85&scoped=true"
import script from "./InitForm.vue?vue&type=script&lang=js"
export * from "./InitForm.vue?vue&type=script&lang=js"
import style0 from "./InitForm.vue?vue&type=style&index=0&id=608a1c85&prod&scoped=true&lang=css"
import style1 from "./InitForm.vue?vue&type=style&index=1&id=608a1c85&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608a1c85",
  null
  
)

export default component.exports